export default "__VITE_ASSET__D3F_DmPy__"